// Constants
import { STORAGE_DATA } from '@/constants/storageData'
import { ROUTE_PATH } from '@/constants/routePath'

const handleLogout = () => {
  window.localStorage.removeItem(STORAGE_DATA.TOKEN)
  window.localStorage.removeItem(STORAGE_DATA.IS_TIMEOUT)
  window.localStorage.removeItem(STORAGE_DATA.SHOPPINGCART_ID)

  window.location.href = ROUTE_PATH.LOGIN
}

export default handleLogout
